import {HlmButtonImports} from "@spartan-ng/helm/button";
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Location} from "@angular/common";
import {SERVER_RESPONSE} from '../../../server-response.token';
import {SeoService} from '../../../services/seo.service';
import {CardFooterComponent} from '../../../../components/card/card-footer/card-footer.component';
import {RouterLink} from '@angular/router';
import {CardBodyComponent} from '../../../../components/card/card-body/card-body.component';
import {CardHeaderComponent} from '../../../../components/card/card-header/card-header.component';
import {CardComponent} from '../../../../components/card/card/card.component';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HlmButtonImports, CardComponent, CardHeaderComponent, CardBodyComponent, RouterLink, CardFooterComponent]
})
export class Error404Component {
  private location = inject(Location);
  private seo = inject(SeoService);


  private serverResponse = inject(SERVER_RESPONSE, {optional: true});

  constructor() {
    // During SSR this sets the real HTTP 404 status on the Express response.
    this.serverResponse?.status(404);
    // Страница 404 не должна индексироваться.
    this.seo.setNoindex();
  }

  back() {
    this.location.back();
  }
}
